import { hash } from '@ember/helper';
import { t } from 'ember-intl';
import {
  HdsIconTile,
  HdsTextDisplay,
  HdsLinkStandalone,
} from '@hashicorp/design-system-components/components';
import { Flex } from 'core/components';
import { boxMargin } from 'core/modifiers';
import Card from 'hcp/components/page/projects/dashboard/card';

const TerraformCard = <template>
  <Card data-test-terraform-card>
    <:header>
      <Flex
        @justifyContent="space-between"
        @alignItems="center"
        @direction="row"
        @grow={{1}}
        @gap="md"
        data-test-terraform-card-header
      >
        <Flex @alignItems="center" @direction="row" @gap="sm">
          <HdsIconTile @icon="terraform-color" />
          <h2 class="hds-typography-display-400">
            {{t "service-card.terraform.title"}}
          </h2>
        </Flex>
      </Flex>
    </:header>
    <:body>
      <Flex @alignItems="start" @direction="column" @gap="xs">
        <HdsTextDisplay
          @size="300"
          @tag="h3"
          {{boxMargin "0 0 sm 0"}}
          data-test-terraform-card-header-resource
        >
          {{t "service-card.terraform.get-started"}}
        </HdsTextDisplay>
        <p class="hds-typography-body-200 hds-font-weight-regular">
          {{t "service-card.terraform.details"}}
        </p>
      </Flex>
    </:body>
    <:footer>
      <HdsLinkStandalone
        @route="terraform"
        @query={{hash project_id=@project.id}}
        @text={{t "service-card.terraform.get-started"}}
        @icon="arrow-right"
        @iconPosition="trailing"
        data-test-terraform-card-cta-link
      />
    </:footer>
  </Card>
</template>;

export default TerraformCard;
